import styled from "styled-components";
import { colors, devices } from "../../../base/styled/variables.styled";
export const Overlay = styled.div `
	position: fixed;
	inset: 0;
	z-index: 1001;

	background: ${colors.black}3f;
	backdrop-filter: blur(6px);
	-webkit-backdrop-filter: blur(6px);

	width: 100vw;
	height: 100vh;
	overflow: auto;
	overscroll-behavior: contain;
	-webkit-overflow-scrolling: touch;

	display: flex;
	justify-content: flex-end;

	opacity: 0;
	pointer-events: none;
	transition: opacity 0.3s ease;

	&[data-open="true"] {
		opacity: 1;
		pointer-events: auto;
	}
`;
export const ModalPanel = styled.div `
	width: 456px;

	@media ${devices.tablets} {
		width: 100vw;
	}

	@media ${devices.mobile} {
		width: 100vw;
	}

	max-width: 100%;
	height: 100%;
	background: ${colors.neutral000};
	box-shadow: -10px 0 30px ${colors.black}2d;

	display: flex;
	flex-direction: column;
	outline: none;

	transform: translate3d(100%, 0, 0);
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	-webkit-transform: translate3d(100%, 0, 0);
	-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

	&[data-open="true"] {
		transform: translate3d(0, 0, 0);
		-webkit-transform: translate3d(0, 0, 0);
	}

	&[data-full-width="true"] {
		width: 100vw;
		max-width: 100vw;
	}
`;
export const BodyModal = styled.div `
	overflow: hidden;
	height: 100dvh;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	-webkit-overflow-scrolling: touch;

	@supports not (height: 100dvh) {
		height: 100vh;
	}
`;
export const ContentModal = styled.div `
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	box-sizing: border-box;
	background: ${colors.neutral000};
	-webkit-overflow-scrolling: touch;

	padding-left: env(safe-area-inset-left);
	padding-right: env(safe-area-inset-right);
	padding-bottom: env(safe-area-inset-bottom);
`;
export const FooterModal = styled.div `
	padding: 16px;
	min-height: 168px;
	border-radius: 8px 8px 0 0;
	box-shadow: 0px -4px 8px 0px ${colors.black}26;
	margin-top: auto;
	gap: 8px;
	z-index: 1;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	display: flex;

	&[data-buttons-row="true"] {
		flex-direction: row;
		justify-content: space-between;
		min-height: auto;
		padding: 24px;
		gap: 12px;
	}
`;
export const ContentInner = styled.div `
	padding: 32px;
	box-sizing: border-box;

	padding-top: max(32px, env(safe-area-inset-top));
	padding-left: max(32px, env(safe-area-inset-left));
	padding-right: max(32px, env(safe-area-inset-right));
	padding-bottom: max(32px, env(safe-area-inset-bottom));

	@media ${devices.mobile} {
		padding-top: 32px;
	}
`;
//# sourceMappingURL=Modal.style.js.map